(() => {
  const stateByProduct = window.GardeniaGiftState || (window.GardeniaGiftState = {});

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getState(productInfo) {
    const productId = productInfo.dataset.productId || productInfo.id || 'product';
    if (!stateByProduct[productId]) {
      stateByProduct[productId] = { card: '', recipient: '', sender: '' };
    }
    return stateByProduct[productId];
  }

  function setPreview(cardField, countEl, previewEl) {
    const max = parseInt(cardField.getAttribute('maxlength'), 10) || 250;
    const remaining = Math.max(0, max - cardField.value.length);
    countEl.textContent = remaining + ' characters remaining';
    previewEl.textContent = cardField.value.trim() ? cardField.value : 'Your message will appear here…';
  }

  function initProduct(productInfo) {
    if (productInfo.querySelector('.gardenia-gift-fields')) return;

    const form = productInfo.querySelector('product-form form');
    if (!form || !form.id) return;

    const quantityBlock = productInfo.querySelector('[id^="Quantity-Form-"]');
    const buyButtons = productInfo.querySelector('product-form');
    const anchor = quantityBlock || buyButtons;
    if (!anchor || !anchor.parentNode) return;

    const sectionKey = productInfo.dataset.section || productInfo.id.replace(/^MainProduct-/, '') || 'main';
    const safeSectionKey = escapeHtml(sectionKey);
    const safeFormId = escapeHtml(form.id);
    const state = getState(productInfo);

    const wrapper = document.createElement('div');
    wrapper.className = 'gardenia-gift-fields';
    wrapper.innerHTML = `
      <div class="gardenia-gift-field">
        <div class="gardenia-gift-label-row">
          <label class="gardenia-gift-label" for="Card-Message-${safeSectionKey}">Message for your card</label>
          <span class="gardenia-gift-required">Required</span>
        </div>
        <div class="field">
          <textarea
            id="Card-Message-${safeSectionKey}"
            data-gardenia-gift-field="card"
            class="text-area field__input product-form__gift-message"
            form="${safeFormId}"
            rows="5"
            maxlength="250"
            required
            aria-required="true"
            aria-describedby="Card-Message-Note-${safeSectionKey} Card-Message-Count-${safeSectionKey}"
          ></textarea>
        </div>
        <div class="product-form__gift-meta-row">
          <p class="product-form__field-note" id="Card-Message-Note-${safeSectionKey}">We'll handwrite this on a Gardenia card.</p>
          <p class="product-form__char-count" id="Card-Message-Count-${safeSectionKey}">250 characters remaining</p>
        </div>
        <div class="gift-message-preview" aria-hidden="true">
          <p class="gift-preview-title">Preview of your card:</p>
          <div class="gift-preview-box" id="Card-Preview-${safeSectionKey}"></div>
        </div>
      </div>
      <div class="product-form__gift-grid">
        <div class="gardenia-gift-field">
          <div class="gardenia-gift-label-row">
            <label class="gardenia-gift-label" for="Recipient-Name-${safeSectionKey}">Recipient name</label>
            <span class="gardenia-gift-required">Required</span>
          </div>
          <div class="field">
            <input
              type="text"
              id="Recipient-Name-${safeSectionKey}"
              data-gardenia-gift-field="recipient"
              class="field__input"
              form="${safeFormId}"
              required
              aria-required="true"
            >
          </div>
        </div>
        <div class="gardenia-gift-field">
          <div class="gardenia-gift-label-row">
            <label class="gardenia-gift-label" for="Sender-Name-${safeSectionKey}">Sender name</label>
            <span class="gardenia-gift-required">Required</span>
          </div>
          <div class="field">
            <input
              type="text"
              id="Sender-Name-${safeSectionKey}"
              data-gardenia-gift-field="sender"
              class="field__input"
              form="${safeFormId}"
              required
              aria-required="true"
            >
          </div>
        </div>
      </div>
    `;

    anchor.parentNode.insertBefore(wrapper, anchor);

    const ensurePropertyInput = (key, propertyName) => {
      let input = form.querySelector('input[data-gardenia-property="' + key + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.dataset.gardeniaProperty = key;
        form.appendChild(input);
      }
      input.name = 'properties[' + propertyName + ']';
      return input;
    };

    const propertyInputs = {
      card: ensurePropertyInput('card', 'Card Message'),
      recipient: ensurePropertyInput('recipient', 'Recipient Name'),
      sender: ensurePropertyInput('sender', 'Sender Name')
    };

    const cardField = wrapper.querySelector('[data-gardenia-gift-field="card"]');
    const recipientField = wrapper.querySelector('[data-gardenia-gift-field="recipient"]');
    const senderField = wrapper.querySelector('[data-gardenia-gift-field="sender"]');
    const countEl = wrapper.querySelector('[id^="Card-Message-Count-"]');
    const previewEl = wrapper.querySelector('[id^="Card-Preview-"]');

    cardField.value = state.card;
    recipientField.value = state.recipient;
    senderField.value = state.sender;
    propertyInputs.card.value = cardField.value;
    propertyInputs.recipient.value = recipientField.value;
    propertyInputs.sender.value = senderField.value;
    setPreview(cardField, countEl, previewEl);

    cardField.addEventListener('input', () => {
      state.card = cardField.value;
      propertyInputs.card.value = cardField.value;
      cardField.setCustomValidity('');
      setPreview(cardField, countEl, previewEl);
    });

    recipientField.addEventListener('input', () => {
      state.recipient = recipientField.value;
      propertyInputs.recipient.value = recipientField.value;
      recipientField.setCustomValidity('');
    });

    senderField.addEventListener('input', () => {
      state.sender = senderField.value;
      propertyInputs.sender.value = senderField.value;
      senderField.setCustomValidity('');
    });

    if (!form.dataset.gardeniaGiftValidation) {
      form.dataset.gardeniaGiftValidation = 'true';
      form.addEventListener('submit', (event) => {
        const currentWrapper = productInfo.querySelector('.gardenia-gift-fields');
        if (!currentWrapper) return;

        const requiredFields = [
          [currentWrapper.querySelector('[data-gardenia-gift-field="card"]'), 'Please enter a card message.'],
          [currentWrapper.querySelector('[data-gardenia-gift-field="recipient"]'), 'Please enter the recipient name.'],
          [currentWrapper.querySelector('[data-gardenia-gift-field="sender"]'), 'Please enter the sender name.']
        ];

        for (const [field, message] of requiredFields) {
          if (field && field.value.trim() === '') {
            event.preventDefault();
            event.stopPropagation();
            field.setCustomValidity(message);
            field.focus();
            field.reportValidity();
            return false;
          }
          if (field) field.setCustomValidity('');
        }
      }, true);
    }
  }

  function initGardeniaGiftFields() {
    document.querySelectorAll('product-info').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGardeniaGiftFields, { once: true });
  } else {
    initGardeniaGiftFields();
  }

  document.addEventListener('shopify:section:load', initGardeniaGiftFields);

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(initGardeniaGiftFields);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
